module.exports = __webpack_public_path__ + "img/visa.c9e95c29.svg";